import createFormValues from '../createFormValues';
import immutable from '../structure/immutable';

export default createFormValues(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/formValues.js
// module id = 1194
// module chunks = 0